// What the Hub card replaces: the six features that are bought as separate tools,
// each with the tool's logo and the price of its cheapest plan that does the job.
// Read by HubReplaces.js for both React Hub cards (the sales page's HubVsAgents and
// PricingPage). The same data as sales-page-next/lib/hubReplaces.ts: change the two
// together. Prices are each company's own pricing page on 23 Oct 2026: Stan Creator,
// Calendly Standard, Teachable Starter, Skool Hobby, Mailchimp Standard (500 contacts)
// and ManyChat Pro. Kajabi Basic is $143 a month billed yearly. Annually shows each
// plan's yearly-billed price per month, Monthly its monthly price (Mailchimp and Skool
// bill monthly only). Card fees on your sales are not included. Other currencies are
// converted from the US prices at the ECB rate of 22 Oct 2026. Update the numbers, the
// check date and the plans named here together.

import stanLogo from '../../../assets/logos/stan.svg';
import calendlyLogo from '../../../assets/logos/calendly.svg';
import teachableLogo from '../../../assets/logos/teachable.svg';
import kajabiLogo from '../../../assets/logos/kajabi.svg';
import skoolLogo from '../../../assets/logos/skool.png';
import mailchimpLogo from '../../../assets/logos/mailchimp.png';
import manychatLogo from '../../../assets/logos/manychat.svg';

// The order the six rows lead the feature list on both cards.
export const REPLACES_ROWS = ['storefront', 'coaching', 'courses', 'communities', 'emails', 'autoDm'];

// width and height are the file's own size (an SVG's viewBox, a PNG's pixels), so
// the image keeps its aspect ratio and reserves its space before it loads. show is
// the height it is shown at.
const LOGOS = {
   stan: { src: stanLogo, alt: 'Stan', width: 100, height: 29.894, show: 15 },
   calendly: { src: calendlyLogo, alt: 'Calendly', width: 100, height: 24.131, show: 14 },
   teachable: { src: teachableLogo, alt: 'Teachable', width: 346, height: 57, show: 13 },
   kajabi: { src: kajabiLogo, alt: 'Kajabi', width: 1199.96, height: 282.5, show: 13 },
   skool: { src: skoolLogo, alt: 'Skool', width: 240, height: 83, show: 14 },
   mailchimp: { src: mailchimpLogo, alt: 'Mailchimp', width: 400, height: 110, show: 16 },
   manychat: { src: manychatLogo, alt: 'ManyChat', width: 100, height: 17.634, show: 13 },
};

// How each row's price line reads: a plain monthly price, "from" the monthly
// price plus a share of sales (Teachable), or the price plus a share (Skool).
export const REPLACES_ROW_INFO = {
   storefront: { logos: [LOGOS.stan], kind: 'plain' },
   coaching: { logos: [LOGOS.calendly], kind: 'plain' },
   courses: { logos: [LOGOS.teachable, LOGOS.kajabi], kind: 'courses' },
   communities: { logos: [LOGOS.skool], kind: 'communities' },
   emails: { logos: [LOGOS.mailchimp], kind: 'plain' },
   autoDm: { logos: [LOGOS.manychat], kind: 'plain' },
};

// Whole units, rounded down, as [billed annually, billed monthly]. USD are the
// list prices. Every other currency is converted from the US price at the ECB
// rate of 22 Oct 2026 and shown with "about" in front, so converted is true.
export const REPLACES_PRICES = {
   USD: {
      converted: false,
      rows: { storefront: [25, 29], coaching: [10, 12], courses: [29, 39], communities: [9, 9], emails: [20, 20], autoDm: [29, 39] },
      total: [122, 148],
   },
   GBP: {
      converted: true,
      rows: { storefront: [18, 21], coaching: [7, 8], courses: [21, 29], communities: [6, 6], emails: [14, 14], autoDm: [21, 29] },
      total: [87, 107],
   },
   EUR: {
      converted: true,
      rows: { storefront: [22, 25], coaching: [8, 10], courses: [25, 34], communities: [8, 8], emails: [17, 17], autoDm: [25, 34] },
      total: [105, 128],
   },
   SEK: {
      converted: true,
      rows: { storefront: [247, 287], coaching: [99, 119], courses: [287, 386], communities: [89, 89], emails: [198, 198], autoDm: [287, 386] },
      total: [1207, 1465],
   },
   AUD: {
      converted: true,
      rows: { storefront: [35, 41], coaching: [14, 17], courses: [41, 55], communities: [12, 12], emails: [28, 28], autoDm: [41, 55] },
      total: [171, 208],
   },
   CAD: {
      converted: true,
      rows: { storefront: [35, 40], coaching: [14, 16], courses: [40, 54], communities: [12, 12], emails: [28, 28], autoDm: [40, 54] },
      total: [169, 204],
   },
   NZD: {
      converted: true,
      rows: { storefront: [44, 51], coaching: [17, 21], courses: [51, 68], communities: [15, 15], emails: [35, 35], autoDm: [51, 68] },
      total: [213, 258],
   },
};
